import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import '../../Styles/HS.css'
import {
  Grid,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import ExpandableText from './ExpandableText'
import How_We_Started_Image from '../../Assets/Images/History_Header.png'
import {
  IMAGE_BASE_PATH_COMMON,
  IMAGE_BASE_PATH_DBRALC,
} from '../../Config/Config'

const HS = (Props) => {
  const location = useLocation()
  const HOD_Message_Data = Props.HS_DATA
  const [dialogOpen, setDialogOpen] = useState(false)

  const openDialog = () => {
    setDialogOpen(true)
  }

  const closeDialog = () => {
    setDialogOpen(false)
  }

  const getHeadingImage = () => {
    if (location.pathname === '/faculty') {
      return (
        <Typography
          variant="h4"
          component="h1"
          sx={{
            textAlign: 'center',
            mb: 4,
            fontWeight: 'bold',
            color: '#494798',
            display: 'inline-block',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              bottom: '-4px',
              width: '100%',
              height: '3px',
              backgroundColor: '#F15215',
              borderRadius: '2px',
            },
          }}
        >
          Our Expert Faculty Team
        </Typography>
      )
    }
    return (
      <img
        src={How_We_Started_Image}
        alt="How We Started"
        loading="lazy"
        placeholder="blur"
        style={{
          width: '100%',
          maxWidth: '600px',
          height: 'auto',
          borderRadius: '8px',
        }}
      />
    )
  }

  return (
    <Box
      sx={{ padding: { xs: '16px', sm: '32px' }, backgroundColor: '#f9f9f9' }}
    >
      {/* Header Image */}
      <Box sx={{ textAlign: 'center', marginBottom: '24px' }}>
        {getHeadingImage()}
      </Box>

      {/* Content Section */}
      <Grid container spacing={4} justifyContent="center">
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              padding: { xs: '8px', md: '16px' },
            }}
          >
            <img
              src={
                HOD_Message_Data?.image
                  ? IMAGE_BASE_PATH_DBRALC + HOD_Message_Data.image
                  : IMAGE_BASE_PATH_COMMON +
                    'Placeholders/Placeholder_Image.jpg'
              }
              alt="HOD"
              loading="lazy"
              placeholder="blur"
              style={{
                width: '100%',
                maxWidth: '600px',
                height: 'auto',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
              onClick={openDialog}
              onError={(e) =>
                (e.target.src =
                  IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg')
              }
            />
            <Typography
              variant="h6"
              sx={{ marginTop: '16px', fontWeight: 'bold' }}
            >
              {HOD_Message_Data.name}
            </Typography>
            <Typography variant="subtitle2" color="primary">
              {HOD_Message_Data.designation}
            </Typography>
          </Box>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <ExpandableText
            text={HOD_Message_Data.description}
            initialChars={800}
            showFullText={false}
          />
        </Grid>
      </Grid>

      {/* Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={closeDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '15px',
            boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
          },
        }}
      >
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={
              HOD_Message_Data?.image
                ? IMAGE_BASE_PATH_DBRALC + HOD_Message_Data.image
                : IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
            }
            alt="Picture_PopUp"
            loading="lazy"
            placeholder="blur"
            style={{
              width: '50%',
              height: 'auto',
              borderRadius: '10px',
            }}
          />
          <DialogTitle style={{ textAlign: 'center', fontWeight: 'bold' }}>
            {HOD_Message_Data.name}
          </DialogTitle>
          <Typography variant="subtitle1" color="primary">
            {HOD_Message_Data.designation}
          </Typography>
          <Typography
            variant="body2"
            style={{ textAlign: 'center', marginTop: '1rem' }}
          >
            {HOD_Message_Data.description}
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button onClick={closeDialog} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default HS
